export enum TicketStatus {
  Created = 'created',
  Closed = 'closed',
}
